import React, { useContext, useState } from 'react';
import { AppContext } from '../../AppContext';
import {
    getDataDB,
    saveDataDB,
    modifyDataModel,
    modifyTextAI,
    countWords,
    isDescriptionField,
    isImageField,
    emailBookNowForm,
    sendEmail,
    handleFontAwesomeRedirect
} from "../../api";
import moment from "moment";

const Bookappointment = () => {
    const { appState } = useContext(AppContext);
    const {
        right: rightResult,
        left: leftResult,

    } = appState?.bookappointment || {};
    const {
        siteName,
        header = {}
        // #ea6645
    } = appState;
    const {
        emails = 'modupe@varetechnologies.com,dipoty0@gmail.com,info@heritagehubfederal.org'
    } = header || {}

    const right = rightResult?.[0] || {}
    const left = leftResult?.[0] || {}


    const [formData, setFormData] = useState({ name: '', email: '', phone: '' });
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);


    const validate = () => {
        const newErrors = {};

        if (!formData.name.trim()) newErrors.name = 'Full name is required';
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email format is invalid';
        }

        if (!formData.phone.trim()) {
            newErrors.phone = 'Phone number is required';
        } else if (!/^\d{7,15}$/.test(formData.phone)) {
            newErrors.phone = 'Phone must be 7–15 digits';
        }

        return newErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        const validationErrors = validate();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            // console.log('Form data:', formData);
            if (!(
                formData?.name,
                formData?.email
            )) {
                return
            }
            emails?.length > 0 &&
                await sendEmail(emailBookNowForm({
                    ...formData,
                    emails,
                })).then(() => {
                    setFormData({});
                });
            await saveDataDB({
                query: {
                    date: moment(),
                    ...formData,
                    emails,
                    siteName: siteName,
                },
                keys: ["email"],
                resource: "vare_banking_appointment",
            }).then(res => {
                setFormData({})
                setTimeout(() => {
                    setLoading(false)
                    // window.open('/', '_self')
                }, 1000)
            })
            setSubmitted(true);
        }
    };

    if (!right?.heading) {
        return
    }

    return (
        <section className="book-appointment parallax section-padding" id="book-appointment">
            <div className="overlay overlay-bg-black" />
            <div className="pattern" />
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="appointment-sec">
                            <div className="row no-gutters">
                                {/* Left Side */}
                                <div className="col-lg-6">
                                    <div className="padding-40 full-height bg-white">
                                        <div className="align-self-center">
                                            <div className="section-heading">
                                                <h3 className="text-custom-blue fw-600">{left.heading}</h3>
                                            </div>
                                            <p className="text-dark">{left.description}</p>
                                            <h6 className="fs-20 mt-4 text-dark">{left.subheading}</h6>
                                            <div className="LOANLY-address">
                                                <p className="text-dark"><span className="fw-600">Address</span>: {left.address}</p>
                                                <p className="text-dark"><span className="fw-600">Email</span>: {left.email}</p>
                                            </div>
                                            <button type="button" className="btn-first btn-submit-fill">
                                                <i className="fas fa-phone mr-2 fs-16" />
                                                <span className="fs-16">{left.phone}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Right Side */}
                                <div className="col-lg-6">
                                    <div className="right-side full-height bg-border">
                                        <div className="section-heading">
                                            <h3 className="text-white fw-600">{right.heading}</h3>
                                        </div>

                                        {submitted ? (
                                            <p className="text-white">Thank you! We'll be in touch shortly.</p>
                                        ) : (
                                            <form className="form-style-2 form-style-3" onSubmit={handleSubmit} noValidate>
                                                <div className="row">
                                                    {right?.form.map((field, index) => {
                                                        if (field.label?.toLowerCase() != 'submit')
                                                            return <div key={index} className="col-md-12">
                                                                <div className="form-group">
                                                                    <div className="input-group">
                                                                        <span className="input-group-preappend">
                                                                            <i className={`fas ${field.icon}`} />
                                                                        </span>
                                                                        <input
                                                                            type={field.type || 'text'}
                                                                            name={field.key}
                                                                            className="form-control"
                                                                            placeholder={field.label}
                                                                            value={formData[field.key] || ''}
                                                                            onChange={handleChange}
                                                                        />
                                                                    </div>
                                                                    {errors[field.key] && <small className="text-danger">{errors[field.key]}</small>}
                                                                </div>
                                                            </div>
                                                    })}
                                                    <div className="col-md-12">
                                                        <button type="submit" className="btn-first btn-submit full-width"
                                                            disabled={loading}>
                                                            {right.form.find(f => f.key === 'button')?.label || 'Submit'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Bookappointment;
